{
  "name": "@prashanttiw/pramana",
  "version": "2.0.0",
  "description": "High-performance, zero-dependency, algorithmic validation library for the Indian context (Aadhaar, PAN, GSTIN, IFSC, Pincode).",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "bin": {
    "pramana": "./dist/cli/index.js"
  },
  "exports": {
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.js",
      "types": "./dist/index.d.ts"
    },
    "./zod": {
      "import": "./dist/zod/index.mjs",
      "require": "./dist/zod/index.js",
      "types": "./dist/zod/index.d.ts"
    },
    "./express": {
      "import": "./dist/express/index.mjs",
      "require": "./dist/express/index.js",
      "types": "./dist/express/index.d.ts"
    },
    "./yup": {
      "import": "./dist/yup/index.mjs",
      "require": "./dist/yup/index.js",
      "types": "./dist/yup/index.d.ts"
    },
    "./valibot": {
      "import": "./dist/valibot/index.mjs",
      "require": "./dist/valibot/index.js",
      "types": "./dist/valibot/index.d.ts"
    },
    "./react": {
      "import": "./dist/react/index.mjs",
      "require": "./dist/react/index.js",
      "types": "./dist/react/index.d.ts"
    },
    "./rhf": {
      "import": "./dist/rhf/index.mjs",
      "require": "./dist/rhf/index.js",
      "types": "./dist/rhf/index.d.ts"
    }
  },
  "sideEffects": false,
  "scripts": {
    "build": "tsup",
    "postbuild": "node -e \"require('fs').chmodSync('dist/cli/index.js', 0o755)\"",
    "test": "vitest",
    "lint": "tsc --noEmit",
    "gen:context": "node scripts/generate-context.js"
  },
  "keywords": [
    "validation",
    "india",
    "aadhaar",
    "pan",
    "gstin",
    "ifsc",
    "pincode",
    "typescript",
    "zero-dependency"
  ],
  "author": "Pramana Team",
  "license": "ISC",
  "devDependencies": {
    "@clack/prompts": "^1.2.0",
    "@testing-library/react": "^16.3.2",
    "@types/express": "^5.0.6",
    "@types/node": "^25.6.0",
    "@types/react": "^19.2.14",
    "@types/supertest": "^7.2.0",
    "boxen": "^8.0.1",
    "chalk": "^5.6.2",
    "cli-table3": "^0.6.5",
    "commander": "^13.1.0",
    "express": "^5.2.1",
    "figlet": "^1.11.0",
    "gradient-string": "^3.0.0",
    "jsdom": "^29.0.2",
    "ora": "^8.2.0",
    "react": "^19.2.5",
    "react-dom": "^19.2.5",
    "react-hook-form": "^7.72.1",
    "supertest": "^7.2.2",
    "tsup": "^8.5.1",
    "typescript": "^5.9.3",
    "valibot": "^1.3.1",
    "vitest": "^4.0.16",
    "yup": "^1.7.1",
    "zod": "^4.2.1"
  },
  "peerDependencies": {
    "express": ">=4.0.0",
    "react": ">=16.8.0",
    "react-hook-form": ">=7.0.0",
    "valibot": "1.3.1",
    "yup": ">=0.32.0",
    "zod": ">=3.0.0"
  },
  "peerDependenciesMeta": {
    "express": {
      "optional": true
    },
    "yup": {
      "optional": true
    },
    "valibot": {
      "optional": true
    },
    "react": {
      "optional": true
    },
    "react-hook-form": {
      "optional": true
    },
    "zod": {
      "optional": true
    }
  }
}
